module.exports = __webpack_public_path__ + "static/media/AegyptiLegend.74c48a5c.png";